import { useEffect } from "react";

export const SITE_URL = "https://nb-couverture-bordeaux.fr";

export const BASE_TITLE = "Couvreur à Bordeaux | NB Couverture — Rénovation & Urgence";
export const BASE_DESC =
  "Couvreur-zingueur à Bordeaux : rénovation, démoussage, urgence fuite 24/7, zinguerie, ardoise, isolation. Devis gratuit — 06 14 31 06 03.";

export function useSeo({ title, description, canonical, schemas = [] }) {
  const schemasKey = JSON.stringify(schemas);
  useEffect(() => {
    if (title) document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);

    let link = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = SITE_URL + canonical;
    }

    const injected = schemas.map((s) => {
      const el = document.createElement("script");
      el.type = "application/ld+json";
      el.setAttribute("data-seo-injected", "1");
      el.textContent = JSON.stringify(s);
      document.head.appendChild(el);
      return el;
    });

    return () => {
      injected.forEach((el) => el.remove());
      document.title = BASE_TITLE;
      if (meta) meta.setAttribute("content", BASE_DESC);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, canonical, schemasKey]);
}

export const orgSchema = {
  "@type": "RoofingContractor",
  name: "NB Couverture",
  telephone: "+33614310603",
  address: { "@type": "PostalAddress", streetAddress: "31 avenue de Bellevue", addressLocality: "Mérignac", postalCode: "33700", addressRegion: "Gironde", addressCountry: "FR" },
};
